module.exports = __webpack_public_path__ + "static/media/facebook-footer-dark.574940a6.svg";